import { render } from "./QuizTemplates.vue?vue&type=template&id=6b1fa9e8"
import script from "./QuizTemplates.vue?vue&type=script&lang=js"
export * from "./QuizTemplates.vue?vue&type=script&lang=js"

import "./QuizTemplates.vue?vue&type=style&index=0&id=6b1fa9e8&lang=scss"
script.render = render

export default script